import "./EmptyResultsComponent.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { DialogDimension } from "@microsoft/teams-js";
import React, { useMemo } from "react";

import { JTBDSelection } from "../../survey/pages/JTBDSelection";
import { useUserInfo } from "../actions/useUserInfo";
import { useTeamsContext } from "../state/TeamsContextProvider";
import { isMobileClient } from "../utils/clientHelper";
import { startCheckoutTask, startTask } from "../utils/startTaskWrapper";
import { getAppId } from "../utils/teamsHelpers";
import useWindowDimensions from "../utils/useWindowDimensions";

type Props = {
  onAuthoringCompletion?: () => void;
};

export const EmptyResultsComponent: React.FC<Props> = ({ onAuthoringCompletion }) => {
  const { user } = useUserInfo();
  const { teamsContext } = useTeamsContext();
  const { loadUser } = useUserInfo();
  const { width } = useWindowDimensions();

  const subscription = useMemo(
    () => user.subscriptions.find(sub => sub.state === "active"),
    [user.subscriptions]
  );
  const upgradeText = "Upgrade for as little as $12/month";

  return (
    <div className="container">
      <div className="empty-results-state">
        <Flex column gap="gap.medium" hAlign="center">
          <Text
            content="Welcome to Polly!"
            size="largest"
            weight="bold"
            align="center"
            color="brand"
          />
          <Text content={"Get started by using our guide below"} align="center" size="large" />
        </Flex>

        <JTBDSelection
          hostPage="empty results"
          hideResponseMeter
          onRouteSelected={(route, width) =>
            showAuthoringSelectionModal(
              `${window.location.origin}${route}`,
              width,
              onAuthoringCompletion
            )
          }
        />

        {!isMobileClient(teamsContext) &&
          (!subscription || subscription.state !== "active" || subscription.type === "trial") && (
            <Flex className="footer-upgrade-link" hAlign="center" gap="gap.small">
              <Text content="Want all that Polly has to offer? " weight="bold" />
              <a
                href="#payment"
                className="brand-link"
                onClick={() => {
                  startCheckoutTask(false, "empty-state-footer", width, () => {
                    loadUser(true);
                  });
                }}
              >
                <Text content={upgradeText} weight="bold" />
              </a>
            </Flex>
          )}
      </div>
    </div>
  );
};

const showAuthoringSelectionModal = (
  url: string,
  width?: number,
  onAuthoringCompletion?: () => void
) => {
  startTask(
    {
      url,
      height: DialogDimension.Large,
      width: width ?? 700,
      title: "Authoring",
      completionBotId: getAppId(),
    },
    onAuthoringCompletion
  );
};
